// FLAGS: none
// The closed set of event names `trackException` may be called with, grouped by the flow that fails.
// Names only — no payload shape is decided here.
export enum AuthInsightEvent {
  RegistrationFailed = "REGISTRATION_FAILED",
  RegisterGuestFailed = "REGISTER_GUEST_FAILED",

  LoginFailed = "LOGIN_FAILED",
  LoginAfterTwoFactorVerificationFailed = "LOGIN_AFTER_TWO_FACTOR_VERIFICATION_FAILED",
  TwoFactorSuccessActionFailed = "TWO_FACTOR_SUCCESS_ACTION_FAILED",
  RefreshAccessTokenFailed = "REFRESH_ACCESS_TOKEN_FAILED",

  ForgotPasswordEmailRequestFailed = "FORGOT_PASSWORD_EMAIL_REQUEST_FAILED",
  ResendCodeEmailFailed = "RESEND_CODE_EMAIL_FAILED",
  VerifyEmailFailed = "VERIFY_EMAIL_FAILED",

  SignUpExternalUserFailed = "SIGN_UP_EXTERNAL_USER_FAILED",
  SignUpExternalUserCodeFailed = "SIGN_UP_EXTERNAL_USER_CODE_FAILED",

  GetExternalUserCodeFlowFailed = "GET_EXTERNAL_USER_CODE_FLOW_FAILED",
  GetExternalUserFailed = "GET_EXTERNAL_USER_FAILED",
  GetGuestUserFailed = "GET_GUEST_USER_FAILED",
}

export enum BookSessionInsightEvent {
  BookingFailed = "BOOKING_FAILED",

  BookingCancellationFailed = "BOOKING_CANCELLATION_FAILED",
  RescheduleBookingFailed = "RESCHEDULE_BOOKING_FAILED",

  GetPsychologistDetailsFailed = "GET_PSYCHOLOGIST_DETAILS_FAILED",
  GetSchedulerTimeSlotsFailed = "GET_SCHEDULER_TIME_SLOTS_FAILED",
  GetAvailableLanguagesFailed = "GET_AVAILABLE_LANGUAGES_FAILED",
  GetSchedulerAvailableTimeSlotsForPsychologistFailed = "GET_SCHEDULER_AVAILABLE_TIMESLOTS_FOR_PSYCHOLOGIST_FAILED",
  GetConsultByIdFailed = "GET_CONSULT_BY_ID_FAILED",
  GetLastCompletedConsultFailed = "GET_LAST_COMPLETED_CONSULT_FAILED",
  GetSchedulerTimeZonesFailed = "GET_SCHEDULER_TIME_ZONES_FAILED",
  GetPsychologistTagsFailed = "GET_PSYCHOLOGIST_TAGS_FAILED",
  SchedulerConsultBookingFailed = "SCHEDULER_CONSULT_BOOKING_FAILED",
  SchedulerConsultWithPsychologistFailed = "SCHEDULER_CONSULT_WITH_PSYCHOLOGIST_FAILED",
  GetNonConfirmedActiveConsultsFailed = "GET_NON_CONFIRMED_ACTIVE_CONSULTS_FAILED",
  GetFocusAreasFailed = "GET_FOCUS_AREAS_FAILED",
}

export enum CustomerIOInsightEvent {
  InitializeFailed = "CUSTOMERIO_INITIALIZE_FAILED",
  IdentifyFailed = "CUSTOMERIO_IDENTIFY_FAILED",
  ClearIdentifyFailed = "CUSTOMERIO_CLEAR_IDENTIFY_FAILED",
}

export enum SsoInsightEvent {
  PopupErrorReturned = "SSO_POPUP_ERROR_RETURNED",
  PopupClosedWithoutResult = "SSO_POPUP_CLOSED_WITHOUT_RESULT",
}

export type AppInsightEvent =
  | AuthInsightEvent
  | BookSessionInsightEvent
  | CustomerIOInsightEvent
  | SsoInsightEvent;
